import moment from "moment";
import { normalizeAbsenceType } from "../Users/Calendar/absenceTypes";

/** `end` is the last absent day, not the exclusive end the API stores. */
export interface AbsenceSpan {
  loAType?: string;
  start?: string;
  end?: string;
}

export interface AbsenceDayRange {
  from?: string;
  to?: string;
}

// Only Monday to Friday count; individual non-working weekdays are not deducted.
const countWorkingDaysInSpan = (span: AbsenceSpan, range?: AbsenceDayRange) => {
  if (!span.start) {
    return 0;
  }
  const start = moment(span.start).startOf("day");
  const lastDay = moment.max(
    span.end ? moment(span.end).startOf("day") : start.clone(),
    start.clone()
  );
  const from = range?.from ? moment.max(start, moment(range.from).startOf("day")) : start;
  const to = range?.to ? moment.min(lastDay, moment(range.to).startOf("day")) : lastDay;

  let days = 0;
  for (const day = from.clone(); day.isSameOrBefore(to, "day"); day.add(1, "day")) {
    if (day.isoWeekday() <= 5) {
      days++;
    }
  }
  return days;
};

export const summarizeAbsences = (absences: AbsenceSpan[], range?: AbsenceDayRange) => {
  const countByType = (loAType: string) =>
    absences
      .filter((absence) => normalizeAbsenceType(absence.loAType) === loAType)
      .reduce((days, absence) => days + countWorkingDaysInSpan(absence, range), 0);

  const sickWithNote = countByType("sickness_sick_note");
  const sickWithoutNote = countByType("sickness");
  const childSickWithNote = countByType("sickness_child_sick_note");
  const childSickWithoutNote = countByType("sickness_child");

  return {
    vacation: countByType("vacation"),
    remainingVacation: countByType("remaining_vacation"),
    sickWithNote,
    sickWithoutNote,
    // The "with AU" days are part of the total, never counted on top of it.
    sickTotal: sickWithNote + sickWithoutNote,
    childSickWithNote,
    childSickWithoutNote,
    childSickTotal: childSickWithNote + childSickWithoutNote,
  };
};
